import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Api, isFolder } from '@citrite/sf-api';
var naturalSortFunction = require('javascript-natural-sort');
naturalSortFunction.insensitive = true;
export function sort(array, sortParams) {
  return sortArray(array, sortParams, defaultSortCompare);
}
export function naturalSort(array, sortParams) {
  return sortArray(array, sortParams, naturalSortCompare);
}
export function fileFolderSort(items, params) {
  var folders = [];
  var files = [];
  naturalSort(items, params).forEach(function (f) {
    if (isFolder(f)) {
      folders.push(f);
    } else {
      files.push(f);
    }
  });
  return [].concat(folders, files);
}
function sortArray(array, params, sortFunction) {
  if (array.length === 0) {
    return array;
  }
  var sortedArray = _toConsumableArray(array);
  sortedArray.sort(function (l, r) {
    return sortFunction(l, r, params);
  });
  return sortedArray;
}
function defaultSortCompare(left, right, params) {
  var p = getPrimitives(left, right, params.key, params.direction);
  return p.left === p.right ? 0 : p.left > p.right ? 1 : -1;
}
function naturalSortCompare(left, right, params) {
  var p = getPrimitives(left, right, params.key, params.direction);
  return naturalSortFunction(p.left, p.right);
}
export function getPrimitives(left, right, key, direction) {
  if (!key) {
    return {
      left: left,
      right: right
    };
  }
  var keyArray = key.split('.');
  for (var i = 0; i < keyArray.length; i++) {
    left = left[keyArray[i]];
    right = right[keyArray[i]];
  }
  if (direction !== Api.sortDirections.ASCENDING) {
    var _ref = [left, right];
    right = _ref[0];
    left = _ref[1];
  }
  return {
    left: left,
    right: right
  };
}